import { FormHTMLAttributes, KeyboardEventHandler } from 'react';

type FormWithoutEnterProps = FormHTMLAttributes<HTMLFormElement>;

export const FormWithoutEnter = (props: FormWithoutEnterProps): JSX.Element => {
  const { children, onKeyDown, ...rest } = props;

  const handleKeyDown: KeyboardEventHandler<HTMLFormElement> = (event) => {
    if (event.key !== 'Enter') {
      onKeyDown?.(event);
      return;
    }

    const target = event.target as HTMLElement;

    // Allow Enter key in elements where it should create new lines or be handled naturally
    const shouldAllowEnter =
      target.tagName === 'TEXTAREA' || target.isContentEditable; // RichTextEditor case

    if (!shouldAllowEnter) {
      event.preventDefault();

      // Blur input elements to dismiss mobile keyboard
      if (target.tagName === 'INPUT') {
        target.blur();
      }
    }

    onKeyDown?.(event);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form {...rest} onKeyDown={handleKeyDown}>
      {children}
    </form>
  );
};
